import {privateApi} from '../utils/axios';

// Create a new event
export const createEvent = async (eventData) => {
  const response = await privateApi.post('/events/create', eventData);
  return response.data;
};

// Get all events for a user
export const getUserEvents = async () => {
  const response = await privateApi.get('/events');
  return response.data;
};

// Get event details
export const getEventDetails = async (eventId) => {
  const response = await privateApi.get(`/events/${eventId}/details`);
  return response.data;
};

// Get event details for multiple events
export const getEventsDetails = async (eventIds) => {
  const response = await privateApi.get(`/events/multi-view/details?eventIds=${eventIds.join(',')}`);
  return response.data;
};

// Update an existing event
export const updateEvent = async (eventId, eventData) => {
  const response = await privateApi.put(`/events/${eventId}`, eventData);
  return response.data;
};

// Delete an event by ID
export const deleteEvent = async (eventId) => {
  const response = await privateApi.delete(`/events/${eventId}`);
  return response.data;
};

// Share an event with a friend
export const shareEventWithFriend = async (eventId, friendId) => {
  const response = await privateApi.post('/event-share/share', { eventId, friendId });
  return response.data;
};

// Get all shared events
export const listSharedEvents = async () => {
  const response = await privateApi.get('/event-share/shared');
  return response.data;
};